// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"styles_widgetContainer__QmWoq"};